import { Link } from 'react-router';
import type { RoutingStatus } from '../api/types-p3';

export function EdgeWarning({ routing, link = false }: { routing?: RoutingStatus; link?: boolean }) {
  if (routing?.edge.state !== 'error') return null;
  return (
    <div className="alert danger" role="alert">
      <strong>edge への反映に失敗しています。接続できない場合があります。</strong>
      <p>{routing.edge.message ?? '自動で再試行します。'}</p>
      {link && <Link to="/routing">接続先を確認する</Link>}
    </div>
  );
}
